<swiper-container
  #sliders
  class="swiper-container"
  (swiperslidechange)="ionSlideDidChange($event)"
>
  <ng-container *ngFor="let slide of slides">
    <swiper-slide>
      <img (click)="slideTap()" [src]="slide.imagen_url" />
    </swiper-slide>
  </ng-container>
</swiper-container>
